<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <!-- <h1>Medical Reimbursements</h1> -->
        <v-row>
          <v-col cols="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Project Code"
              v-model="projectFile.projectDesc"
              :class="classPadding"
              clearable
              readonly
              @click:clear="clearProj"
            >
              <template slot="append">
                <v-icon @click.stop="searchProj">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Designation"
              v-model="projectFile.desDesc"
              :class="classPadding"
              clearable
              readonly
              @click:clear="clearDes"
            >
              <template slot="append">
                <v-icon @click.stop="searchDes">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Quantity"
              :class="classPadding"
              v-model="projectFile.quantity"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Remarks"
              :class="classPadding"
              v-model="projectFile.remarks"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <pagination :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </pagination>

      <v-dialog v-model="editDialog" width="700" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Edit</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="4" :class="classPadding">
                <v-text-field
                  label="Project Code"
                  v-model="editProjectFile.projectDesc"
                  :class="classPadding"
                  clearable
                  readonly
                  @click:clear="clearProj"
                >
                  <template slot="append">
                    <v-icon @click.stop="searchProj">mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" :class="classPadding">
                <v-text-field
                  label="Designation"
                  v-model="editProjectFile.desDesc"
                  :class="classPadding"
                  clearable
                  readonly
                  @click:clear="clearDes"
                >
                  <template slot="append">
                    <v-icon @click.stop="searchDes">mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
                <v-text-field
                  label="Quantity"
                  :class="classPadding"
                  v-model="editProjectFile.quantity"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
                <v-text-field
                  label="Remarks"
                  :class="classPadding"
                  v-model="editProjectFile.remarks"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click.stop="editDialog = false"
              >Close</v-btn
            >
            <v-btn
              text
              color="success"
              @click.stop="update"
              :loading="isUpdating"
              v-if="userAccess.update >= 1"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-dialog v-model="projCodeDialog" width="900">
      <v-card>
        <v-card-title>
          <span class="headline">Project Code File</span>
        </v-card-title>
        <v-card-text>
          <project-code-pagination :show-title="false" :show-dense="false">
            <template slot="actions" slot-scope="{ item }">
              <v-btn @click.stop="selectProj(item)" text>Select</v-btn>
            </template>
          </project-code-pagination>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="projCodeDialog = false" text
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Designation -->
    <v-dialog v-model="desigDialog" width="900">
      <v-card>
        <v-card-title>
          <span class="headline">Designation</span>
        </v-card-title>
        <v-card-text>
          <designation-pagination :show-title="false" :show-dense="false">
            <template slot="actions" slot-scope="{ item }">
              <v-btn @click.stop="selectDes(item)" text>Select</v-btn>
            </template>
          </designation-pagination>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="desigDialog = false" text
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Pagination from "./Pagination";
import ProjectCodePagination from "../project-list/Pagination";
import DesignationPagination from "../../../../employment-info/employee-level/designation/List";
import userAccessMixin from "../../../../../../mixins/userAccessMixin";
// import AreaPagination from "../../../../employment-info/organizational-level/area/Pagination";
// import List from "./List";
const API_ENDPOINT = "/api/projectDetails";
export default {
  metaInfo: {
    title: "Project File",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    // List
    Pagination,
    // AreaPagination,
    ProjectCodePagination,
    DesignationPagination
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    isUpdating: false,
    projectFile: {},
    componentKey: 0,
    editProjectFile: {},
    editDialog: false,
    areaDialog: false,
    projCodeDialog: false,
    desigDialog: false
  }),
  methods: {
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}`, this.projectFile)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      var rel = Object.assign({}, item);
      this.editProjectFile.projectCode = rel.projectCode;
      this.editProjectFile.projectDesc = rel.projectDesc;
      this.editProjectFile.desCode = rel.desCode;
      this.editProjectFile.desDesc = rel.desDesc;
      this.editProjectFile.quantity = rel.quantity;
      this.editProjectFile.remarks = rel.remarks;
      this.editProjectFile.id = rel.id;
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.id}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.projectFile = {};
      this.forceRerender();
      this.editDialog = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;

      this.$axios
        .put(`${API_ENDPOINT}`, this.editProjectFile)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    searchProj() {
      this.projCodeDialog = true;
    },
    selectProj(item) {
      if (!this.editDialog) {
        this.projectFile.projectCode = item.projectCode;
        this.projectFile.projectDesc = item.projectDesc;
      } else {
        this.editProjectFile.projectCode = item.projectCode;
        this.editProjectFile.projectDesc = item.projectDesc;
      }
      this.projCodeDialog = false;
    },
    clearProj() {
      if (!this.editDialog) {
        this.projectFile.projectCode = null;
        this.projectFile.projectDesc = null;
      } else {
        this.editProjectFile.projectCode = null;
        this.editProjectFile.projectDesc = null;
      }
    },
    searchDes() {
      this.desigDialog = true;
    },
    selectDes(item) {
      if (!this.editDialog) {
        this.projectFile.desCode = item.desCode;
        this.projectFile.desDesc = item.desDesc;
      } else {
        this.editProjectFile.desCode = item.desCode;
        this.editProjectFile.desDesc = item.desDesc;
      }
      this.desigDialog = false;
    },
    clearDes() {
      if (!this.editDialog) {
        this.projectFile.desCode = null;
        this.projectFile.desDesc = null;
      } else {
        this.editProjectFile.desCode = null;
        this.editProjectFile.desDesc = null;
      }
    }
  },
  created() {
    this.getUserAccessRights("ProjctFile");
  }
};
</script>
